import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SeoDelete } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchSeoDelete = createAsyncThunk(
    'seoGet/fetchSeoDelete',
    async ({ id }) => {
        const response = await SeoDelete(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const seoDeleteSlice = createSlice({
    name: 'seoDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSeoDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSeoDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSeoDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default seoDeleteSlice.reducer;
